import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonPublishProduct(props) {
    const map = useMapContext()

    if (! (
        map.permission.has('write') &&
        /^(DRAFT|REVISE)$/.test(map.dp.stsCode)
    )) {
        return null
    }

    return (
        <MenuButton
            onClick={() => map.publish()}
            {...props}
        >
            发布
        </MenuButton>
    )
}
